import { render, staticRenderFns } from "./CrewLaborRecord.vue?vue&type=template&id=647a501f"
import script from "./CrewLaborRecord.vue?vue&type=script&lang=js"
export * from "./CrewLaborRecord.vue?vue&type=script&lang=js"
import style0 from "./CrewLaborRecord.vue?vue&type=style&index=0&id=647a501f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports